function getElementArray(FenceObject) {
    const elementTypes = { post: 0, corner: 1, end: 2, gate: 3 }
    const bracetypeIsNone = 2

    class FenceElement {
        constructor(elementType, matsType, braceType, qty) {
            this.elementID = elementType
            this.matsID = matsType
            this.braceID = braceType
            this.qty = qty
        }

        // DEBUG RPT email_bom_rpt_element: [],
        // reportString() {
        //     let braceString =
        //         this.brace_ID === undefined
        //             ? '.'
        //             : ` braced using a ${Brace_ID[this.brace_ID]} diagonal`
        //     let multple1 = ''
        //     let multple2 = ''
        //     const elementTxt =
        //         Mats_ID[this.mats_ID] === 't-post'
        //             ? ''
        //             : ` ${Element_ID[this.element_ID]}`
        //     let filterKey = ''
        //     let gateProvokedEnds = ''

        //     if (this.element_ID === 0 || this.brace_ID === 2) {
        //         braceString = ''
        //     }
        //     if (this.element_ID === 3) {
        //         gateProvokedEnds = ` - (the extra hardware necessary for ${
        //             this.qty * 2
        //         } ends is included)`
        //     }
        //     multple1 = this.qty > 1 ? 'are ' : 'is '
        //     multple2 = this.qty > 1 ? 's' : ''

        //     filterKey = g_ebfApp_debugSTATUS
        //         ? `\n -- and filter key is ${this.element_ID}${this.mats_ID}${this.brace_ID}`
        //         : ''
        //     this.email_bom_rpt_element = [
        //         this.brace_ID,
        //         this.mats_ID,
        //         this.element_ID,
        //         this.qty,
        //     ]

        //     return `There ${multple1}${this.qty} ${
        //         Mats_ID[this.mats_ID]
        //     }${elementTxt}${multple2}${braceString}${gateProvokedEnds}${filterKey}.<br>`
        // }
    }

    function loadElements() {
        let elementArray = []

        let postElement = {}
        let cornerElement = {}
        let endElement = {}
        let gateElement = {}

        postElement = new FenceElement(
            elementTypes.post,
            FenceObject.p_mats,
            bracetypeIsNone,
            FenceObject.fencePosts
        )
        cornerElement = new FenceElement(
            elementTypes.corner,
            FenceObject.c_mats,
            FenceObject.c_hbrace,
            FenceObject.corners
        )
        gateElement = new FenceElement(
            elementTypes.gate,
            FenceObject.g_mats,
            FenceObject.g_hbrace,
            FenceObject.gates
        )
        elementArray.push(postElement, cornerElement, gateElement)

        if (FenceObject.ends) {
            endElement = new FenceElement(
                elementTypes.end,
                FenceObject.e_mats,
                FenceObject.e_hbrace,
                FenceObject.ends
            )
            elementArray.push(endElement)
        }
        // console.table(elementArray)
        return elementArray
    }

    return loadElements()
}

export { getElementArray }
